document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-nv-product-carousel]').forEach((root) => {
    const slides = [...root.querySelectorAll('[data-carousel-slide]')];
    const dots = [...root.querySelectorAll('[data-carousel-dot]')];
    const count = root.querySelector('[data-carousel-count]');
    if (!slides.length) return;
    let index = 0;
    let touchX = 0;
    const show = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, current) => {
        const active = current === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach((dot, current) => {
        if (current === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (count) count.textContent = `${index + 1} / ${slides.length}`;
    };
    root.querySelector('[data-carousel-prev]')?.addEventListener('click', () => show(index - 1));
    root.querySelector('[data-carousel-next]')?.addEventListener('click', () => show(index + 1));
    dots.forEach((dot, current) => dot.addEventListener('click', () => show(current)));
    root.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') show(index - 1);
      if (event.key === 'ArrowRight') show(index + 1);
    });
    root.addEventListener('touchstart', (event) => { touchX = event.changedTouches[0].clientX; }, { passive: true });
    root.addEventListener('touchend', (event) => {
      const delta = event.changedTouches[0].clientX - touchX;
      if (Math.abs(delta) > 45) show(index + (delta < 0 ? 1 : -1));
    }, { passive: true });
    show(0);
  });

  const header = document.querySelector('[data-nv-header]');
  if (header) {
    const update = () => header.classList.toggle('is-scrolled', window.scrollY > 24);
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

});
